module.exports = __webpack_public_path__ + "img/xmhsj.c83f89d7.jpg";